import Image from 'next/legacy/image'

import React from 'react'

import dragon from '@/assets/gif/dragon.gif'
import sticks from '@/assets/gif/sticks.gif'
import css from '@/styles/easterEgg.module.css'

const easterEggPrivateRoute = (setEasterEggTag) => {
  setEasterEggTag(
    <>
      <div className={css['easter-egg-dragon']}>
        <Image
          src={dragon.src}
          width={370}
          height={208}
          alt='???'
        />
      </div>
      <div className={css['easter-egg-corner']}>
        <Image
          src={sticks.src}
          alt='???'
          width={370}
          height={208}
        />
      </div>
    </>
  )
  window.setTimeout(() => {
    setEasterEggTag(
      <div className={css['easter-egg-corner']}>
        <p className='w-64 mb-[17px] bg-white'>
          Please, if you read this, I&apos;m a developer that has been removed with the privelege of
          freedom due to <b>James White</b>, <b>John Park</b>
          and <b>Paul Trucker</b>. I haven&apos;t seen the light in days. They tricked me promising
          some Bitcoin and obliged me to code in javascript (oh god). Please call HR asap. Atte. GH,
          thanks.
        </p>
      </div>
    )
    window.setTimeout(() => {
      setEasterEggTag(<></>)
    }, 21000)
  }, 25000)
}

export { easterEggPrivateRoute }
